import React, { Component } from 'react';
import { Segment, Popup, Button, Label } from 'semantic-ui-react';

class InsuredName extends Component {
    constructor(props){
        super(props);

        this.state = {
            confirmed: props.confirmed,
        }
    }

    handleConfirmClick = () => {
        this.setState({ confirmed: true });
        this.props.onConfirmClick();
    }

    render() {
        const { confirmed } = this.state;
        const { contactBureauEmail, readOnlyMode } = this.props;
        const hideButtons = confirmed || readOnlyMode;
        let insuredMessage;
        if (hideButtons) {
            insuredMessage = 'Name of insured:';
        } else {
            insuredMessage = 'Is this the name of the insured?';
        }

        return (
            <Segment>
                <Label color='green' ribbon>{insuredMessage}</Label>
                <Segment><b>{this.props.insuredName}</b></Segment>
                    {!hideButtons && (<Button.Group>
                        <Button color='green' onClick={this.handleConfirmClick}>Yes, Continue</Button>
                        <Button.Or />
                        <Popup
                            trigger={<Button color='red' as='a' href={contactBureauEmail}>No, Contact Bureau</Button>}
                            content={<b>Double check that the Coverage ID number entered is correct before contacting the Bureau.</b>}
                            position='right center'
                        />
                    </Button.Group>)}
            </Segment>
        );
    }
}

export default InsuredName;